import React, { FC } from 'react'

import { clsx } from 'clsx'
import { useController } from 'react-hook-form'

import Lock from 'Icons/lock.svg'

import ErrorMessage from 'Components/ErrorMessage'
import FormErrors from 'Components/FormErrors'
import PhoneInput from 'Components/PhoneInput'

interface Props {
  disabled?: boolean
  submitting?: boolean
}

export const Phone: FC<Props> = ({ disabled, submitting }) => {
  const { field, meta } = useController({
    name: 'phone',
    rules: { required: 'Phone is required' },
  })
  const { locationCountryIsoCodes } = window.VARIABLES
  const defaultCountry = locationCountryIsoCodes[0] || 'US'
  const continueLabel = submitting ? 'Verifying' : 'Continue'
  const describedBy =
    [meta.invalid ? 'profile-login-phone-error' : null, disabled ? 'profile-login-phone-lock' : null]
      .filter(Boolean)
      .join(' ') || undefined

  return (
    <div className="position-relative d-flex flex-column align-items-start mb-2 user-profile-login__field-group user-profile-field">
      {/* Once locked, the step's own heading and description already name the
          field, so the visible label is just noise above a read-only value. */}
      <label className={clsx(disabled ? 'sr-only' : 'user-profile-field__label')} htmlFor="profile-login-phone">
        Phone number
      </label>
      <div className="user-profile-login__phone-row">
        <PhoneInput
          {...field}
          required
          addInternationalOption={false}
          autoComplete="tel"
          countryOptionsOrder={locationCountryIsoCodes}
          defaultCountry={defaultCountry}
          disabled={disabled}
          id="profile-login-phone"
          numberInputProps={{
            className: 'form-control',
            'aria-describedby': describedBy,
            'aria-invalid': meta.invalid,
          }}
          placeholder="Enter your phone number"
        />
        {disabled ? (
          <span aria-hidden="true" className="user-profile-login__phone-lock">
            <Lock />
          </span>
        ) : (
          <button
            aria-label={continueLabel}
            className={clsx('btn btn-accent user-profile-login__phone-submit', { btn_loading: submitting })}
            disabled={submitting}
            type="submit"
          >
            {continueLabel}
          </button>
        )}
      </div>
      {disabled ? (
        <span className="sr-only" id="profile-login-phone-lock">
          Phone number is locked while you verify the code
        </span>
      ) : null}
      <ErrorMessage as={FormErrors} id="profile-login-phone-error" name="phone" />
    </div>
  )
}
